<template>
  <svg
    width="12px"
    height="16px"
    viewBox="0 0 12 16"
    version="1.1"
    xmlns="http://www.w3.org/2000/svg"
  >
    <g
      id="Page-1"
      stroke="none"
      stroke-width="1"
      fill="none"
      fill-rule="evenodd"
    >
      <g
        id="lock-2"
        fill="#516371"
        fill-rule="nonzero"
      >
        <path
          id="Lock-outline"
          d="M2.08333333,7.08333333 C1.8225322,7.08333333 1.61111111,7.28853616 1.61111111,7.54166667
      L1.61111111,13.9583333 C1.61111111,14.2114638 1.8225322,14.4166667 2.08333333,14.4166667 L10.5833333,14.4166667
      C10.8441345,14.4166667 11.0555556,14.2114638 11.0555556,13.9583333 L11.0555556,7.54166667 C11.0555556,7.28853616
      10.8441345,7.08333333 10.5833333,7.08333333 L2.08333333,7.08333333 Z M2.08333333,6.16666667
      L10.5833333,6.16666667 C11.3657367,6.16666667 12,6.78227514 12,7.54166667 L12,13.9583333 C12,14.7177249
      11.3657367,15.3333333 10.5833333,15.3333333 L2.08333333,15.3333333 C1.30092994,15.3333333 0.666666667,14.7177249
      0.666666667,13.9583333 L0.666666667,7.54166667 C0.666666667,6.78227514 1.30092994,6.16666667
      2.08333333,6.16666667 Z M6.36111111,9.375 C6.63725349,9.375 6.86111111,9.58020282 6.86111111,9.83333333
      L6.86111111,11.6666667 C6.86111111,11.9197972 6.63725349,12.125 6.36111111,12.125 C6.08496874,12.125
      5.86111111,11.9197972 5.86111111,11.6666667 L5.86111111,9.83333333 C5.86111111,9.58020282 6.08496874,9.375
      6.36111111,9.375 Z M6.33333333,0.666666667 C8.41974239,0.666666667 10.1111111,2.30828925 10.1111111,4.33333333
      L10.1111111,6.16666667 L9.16666667,6.16666667 L9.16666667,4.33333333 C9.16666667,2.81455027 7.89814012,1.58333333
      6.33333333,1.58333333 C4.76852654,1.58333333 3.5,2.81455027 3.5,4.33333333 L3.5,6.16666667 L2.55555556,6.16666667
      L2.55555556,4.33333333 C2.55555556,2.30828925 4.24692428,0.666666667 6.33333333,0.666666667 Z"
        />
      </g>
    </g>
  </svg>
</template>

<script>
export default {
  name: 'TcLock'
}
</script>
